





















































































import {Component, Ref, Vue} from "vue-property-decorator";
import {ActionUserItem} from "@/store/user_management/action_users/types";
import {Action, Getter} from "vuex-class";
import {SelectWings, InputWings, TextareaWings} from "wings-ui-components";
import {cloneDeep} from "lodash";
import {colorClassByStatus} from '@/utils/page-utils';
import {dateFilter} from "@/utils/date-util";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

@Component({components: {SelectWings, InputWings, TextareaWings}, methods: {colorClassByStatus}, filters: {dateFilter},})
export default class ActionUser extends Vue {
  @Getter("objectTypes") objectTypesList: any;
  @Getter("systemUsersAction") systemUsersActionList: any;
  @Action("getActionUserItem") actionGetItem: any;
  @Ref("validator") validator: any;
  @Action("actionLog") actionLog: any;

  private objectType: any;
  private systemUserAction: any;
  private item = this.defaultItem();
  private itemSaved: any;
  private logObject: ActionLog = {};

  defaultItem(): ActionUserItem {
    return {
      id: 1,
      object_name: '',
      action: ''
    };
  }

  created() {
    if (this.$route.params.id) {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "User action",
        addititional_info: getTranslatedParams({id: this.$route.params.id})
      }
      this.actionGetItem(this.$route.params.id).then((data: ActionUserItem) => {
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        this.actionLog(this.logObject);
      }).catch(()=> {
        this.actionLog({...this.logObject, action_status: "failed"})
      });
      this.objectType = new Map(
          this.objectTypesList.map((object:any) => {
            return [object.eng_name, object.rus_name]
          })
      );
      this.systemUserAction = new Map(
          this.systemUsersActionList.map((object:any) => {
            return [object.eng_name, object.rus_name]
          })
      );
    }
  }

  getSourceName(name: any) {
    let value = name?.replaceAll('.', '_');
    return this.$i18n.t(`old_pages.${value}`)
  }

  back(): void {
    this.$router.push('/user_management/action_users/');
  }
};
